/**
 * Rhenus RVK API
 * \"Rhenus RVK user and admin API Definitions\"
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Observable } from "rxjs";
import { Headers } from "../Headers";
import { HttpResponse } from "../HttpResponse";

import { JSONaddUserToLocationreturn } from "../model/jSONaddUserToLocationreturn";
import { JSONCustomerProfil } from "../model/jSONCustomerProfil";
import { JSONMyName } from "../model/jSONMyName";
import { Response } from "../model/response";

export abstract class RvkUserServiceInterface {
  /**
   * disableUser
   *
   * @param loginName Loginname to disable
   */

  public abstract disableUserUsingGET(
    loginName: string,
    observe?: "body",
    headers?: Headers
  ): Observable<Response>;
  public abstract disableUserUsingGET(
    loginName: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<Response>>;
  /**
   * enableUser
   *
   * @param loginName Loginname to enable
   */

  public abstract enableUserUsingGET(
    loginName: string,
    observe?: "body",
    headers?: Headers
  ): Observable<Response>;
  public abstract enableUserUsingGET(
    loginName: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<Response>>;
  /**
   * generateNewPassword
   *
   * @param loginname Generate a new password for the given loginName user
   */

  public abstract generateNewPasswordUsingPUT(
    loginname: string,
    observe?: "body",
    headers?: Headers
  ): Observable<JSONaddUserToLocationreturn>;
  public abstract generateNewPasswordUsingPUT(
    loginname: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONaddUserToLocationreturn>>;
  /**
   * getCustomerProfile
   *
   */

  public abstract getCustomerProfileUsingGET(
    observe?: "body",
    headers?: Headers
  ): Observable<JSONCustomerProfil>;
  public abstract getCustomerProfileUsingGET(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONCustomerProfil>>;
  /**
   * myName
   *
   */

  public abstract myNameUsingGET(
    observe?: "body",
    headers?: Headers
  ): Observable<JSONMyName>;
  public abstract myNameUsingGET(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<JSONMyName>>;
  /**
   * sendcsv
   *
   */

  public abstract sendcsvUsingGET(
    observe?: "body",
    headers?: Headers
  ): Observable<any>;
  public abstract sendcsvUsingGET(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any>>;
  /**
   * testcsv
   *
   */

  public abstract testcsvUsingGET(
    observe?: "body",
    headers?: Headers
  ): Observable<any>;
  public abstract testcsvUsingGET(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any>>;
  /**
   * updatecontactperson
   *
   */

  public abstract updatecontactpersonUsingGET(
    observe?: "body",
    headers?: Headers
  ): Observable<any>;
  public abstract updatecontactpersonUsingGET(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any>>;
}
